import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HttpUrlBuilderService {

  constructor() { }

  createUrl(protocol = 'http', domain, port = 80, path = "") {
    return protocol + "://" + domain + ":" + port + path;
  }

  createParamUrl(protocol = 'http', domain, port = 80, path = "", httpParams) {
    return protocol + "://" + domain + ":" + port + path + "?" + httpParams.toString();
  }

  createImplicitPortUrl(protocol = 'http', domain, path) {
    return protocol + "://" + domain + path;
  }

  createImplicitPortParamUrl(protocol = 'http', domain, path, httpParams) {
    return protocol + "://" + domain + path + "?" + httpParams.toString();
  }
}
